import { format, isValid, parseISO } from 'date-fns';
import { tr } from 'date-fns/locale';

/** Yüzde girdisinden yalnızca sayıyı çıkarır (örn. "%15" → "15"). */
export const normalizeBannerPercent = (value?: string | null): string => {
  const digits = String(value || '').replace(/[^\d]/g, '');
  if (!digits) return '';
  const n = Math.min(100, Math.max(0, parseInt(digits, 10)));
  if (Number.isNaN(n)) return '';
  return String(n);
};

/** Kartta büyük gösterim: "15" → "%15" */
export const formatBannerPercentLabel = (value?: string | null): string => {
  const n = normalizeBannerPercent(value);
  return n ? `%${n}` : '';
};

const parseYmd = (value?: string | null): Date | null => {
  const raw = String(value || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
  const d = parseISO(raw);
  return isValid(d) ? d : null;
};

export const toYmd = (value: Date | null | undefined): string => {
  if (!value || !isValid(value)) return '';
  return format(value, 'yyyy-MM-dd');
};

export const ymdToDate = (value?: string | null): Date | null => parseYmd(value);

/** Başlangıç / bitiş → "10 Temmuz - 31 Ağustos" (yıl yazılmaz) */
export const formatBannerDateRange = (startDate?: string | null, endDate?: string | null): string => {
  const start = parseYmd(startDate);
  const end = parseYmd(endDate);
  if (!start && !end) return '';
  if (start && !end) return format(start, 'd MMMM', { locale: tr });
  if (!start && end) return format(end, 'd MMMM', { locale: tr });
  if (!start || !end) return '';

  const sameMonth =
    start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();

  if (sameMonth) {
    return `${format(start, 'd', { locale: tr })} - ${format(end, 'd MMMM', { locale: tr })}`;
  }
  return `${format(start, 'd MMMM', { locale: tr })} - ${format(end, 'd MMMM', { locale: tr })}`;
};

export const resolveBannerDateLabel = (card: {
  date?: string;
  startDate?: string;
  endDate?: string;
}): string => {
  const fromRange = formatBannerDateRange(card.startDate, card.endDate);
  if (fromRange) return fromRange;
  // Eski kayıtlarda yıl varsa gösterimde temizle
  return String(card.date || '')
    .trim()
    .replace(/\s+\d{4}\b/g, '');
};
